var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlack1 = function SvgSlack1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 43,
    fill: "none",
    viewBox: "0 0 39 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2315_173531)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A154B",
    stroke: "#fff",
    strokeWidth: 1.369,
    d: "M21.029 3.061 33.19 10.1a2.8 2.8 0 0 1 1.395 2.423v14.078a2.8 2.8 0 0 1-1.395 2.423l-12.161 7.04c-.863.498-1.925.498-2.788 0L6.08 29.023a2.8 2.8 0 0 1-1.396-2.423V12.523A2.8 2.8 0 0 1 6.08 10.1L18.24 3.06c.863-.5 1.925-.5 2.788 0Z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#clip0_2315_173531)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M15.312 21.283a1.89 1.89 0 0 1-1.892 1.887 1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888h1.892zM15.806 21.283a1.89 1.89 0 0 1 1.892-1.889 1.89 1.89 0 0 1 1.892 1.889v4.72a1.89 1.89 0 0 1-1.892 1.888 1.89 1.89 0 0 1-1.892-1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M17.698 14.716a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888 1.89 1.89 0 0 1 1.892 1.888v1.888zM17.698 15.212A1.89 1.89 0 0 1 19.59 17.1a1.89 1.89 0 0 1-1.892 1.888h-4.73a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M24.348 17.1a1.89 1.89 0 0 1 1.892-1.888 1.89 1.89 0 0 1 1.892 1.888 1.89 1.89 0 0 1-1.892 1.888h-1.892zM23.854 17.1a1.89 1.89 0 0 1-1.892 1.889A1.89 1.89 0 0 1 20.07 17.1v-4.72a1.89 1.89 0 0 1 1.892-1.889 1.89 1.89 0 0 1 1.892 1.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M21.962 23.667a1.89 1.89 0 0 1 1.892 1.888 1.89 1.89 0 0 1-1.892 1.888 1.89 1.89 0 0 1-1.892-1.888v-1.888zM21.962 23.17a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888h4.73a1.89 1.89 0 0 1 1.892 1.889 1.89 1.89 0 0 1-1.892 1.887z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2315_173531"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.615 10.032h18.43v18.426h-18.43z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2315_173531",
    width: 38.524,
    height: 42.376,
    x: 0.373,
    y: 0.187,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.813
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2315_173531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2315_173531",
    result: "shape"
  })))));
};
export default SvgSlack1;